import { SheetView } from './SheetView';
import { SheetsView } from './SheetsView';
import type { Workbook } from '@/model/workbook';
import { useState } from 'react';

export function WorkbookView({ workbook }: { workbook: Workbook }) {
  const [sheetIndex, setSheetIndex] = useState(0);

  const sheet = workbook.sheets[sheetIndex]!;

  return (
    <div className="flex w-full grow flex-col">
      <SheetView sheet={sheet} />
      <SheetsView
        workbook={workbook}
        sheetIndex={sheetIndex}
        setSheetIndex={setSheetIndex}
      />
    </div>
  );
}
